import { render, staticRenderFns } from "./ContractTypeForm.vue?vue&type=template&id=01a63f0a"
import script from "./ContractTypeForm.vue?vue&type=script&lang=js"
export * from "./ContractTypeForm.vue?vue&type=script&lang=js"
import style0 from "./ContractTypeForm.vue?vue&type=style&index=0&id=01a63f0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports